
import "@sparta.falcon.modules/software-details-with-images-module/dist/styles.css"


import secureLinkUtility from "@sparta.sales.utilities/secure-link-utility/dist/es6.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"

import "@sparta.common.modules/mbox-module/dist/es6.js"
import "@sparta.falcon.modules/software-details-with-images-module/dist/es6.js"
import "@sparta.falcon.modules/software-details-with-images-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
